import React from "react";
var __jsx = React.createElement;
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { SELL_CAR_SCREENS } from "@/pages/sell-my-car/constants/screens";
import FlowOption from "@/pages/sell-my-car/components/FlowOption";
import FlowOptionBody from "@/pages/sell-my-car/components/FlowOptionBody";
import { useTranslation } from "@i18n";
import FlowStepTitle from "@/pages/sell-my-car/components/FlowStepTitle";
import FlowSearchBar from "@/pages/sell-my-car/components/FlowSearchBar";
import { useCallback, useEffect, useState } from "react";
import FlowScreenHeaderSpacing from "@/pages/sell-my-car/components/FlowScreenHeaderSpacing";
import FlowScreenBodySpacing from "@/pages/sell-my-car/components/FlowScreenBodySpacing";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import FlowZeroResult from "@/pages/sell-my-car/components/FlowZeroResult";
import useBoolean from "@hooks/useBoolean";
import { If } from "@componentsShared/Conditional/If";
import FlowOptionLoading from "@/pages/sell-my-car/components/FlowOptionLoading";
import { useLang } from "@/common/Contexts/LanguageContext";
var CarModelScreen = function CarModelScreen() {
  var _state$availableModel;
  var _useScreenNavigation = useScreenNavigation(),
    navActions = _useScreenNavigation.actions;
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    actions = _useSellCarData.actions;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState(null),
    filteredModels = _useState[0],
    setFilteredModels = _useState[1];
  var _useState2 = useState(null),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var loading = useBoolean(true);
  var lang = useLang();
  var handleModelSelect = function handleModelSelect(model) {
    var _state$brandsData;
    actions.selectModel(model);

    // Check if the model has available extensions/trims
    var hasExtensions = (_state$brandsData = state.brandsData) === null || _state$brandsData === void 0 ? void 0 : _state$brandsData.extensions.some(function (ext) {
      return ext.model_id === model.id;
    });

    // Skip extension screen if no extensions available
    if (hasExtensions) {
      navActions.navigateToScreen(SELL_CAR_SCREENS.CAR_EXTENSION);
    } else {
      // Skip to year screen
      navActions.navigateToScreen(SELL_CAR_SCREENS.CAR_YEAR);
    }
  };
  var searchModelsWrapper = useCallback(function (_items, searchTerm, limit) {
    setSearchTerm(searchTerm);
    return actions.searchModels(searchTerm, limit);
  }, [actions.searchModels]);
  var handleSearchResults = useCallback(function (results) {
    setFilteredModels(results);
    setTimeout(function () {
      loading.setFalse();
    }, 300);
  }, []);

  // Handle case when there are 8 or fewer models (no search bar rendered)
  useEffect(function () {
    if (state.availableModels && state.availableModels.length <= 8) {
      setFilteredModels(state.availableModels);
      loading.setFalse();
    }
  }, [state.availableModels]);
  if (!state.selection.make) {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-4"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-red-500"
    }, "Please select a brand first"));
  }
  if (state.availableModels.length === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-4"
    }, /*#__PURE__*/React.createElement("p", null, "No models available for ", state.selection.make.name));
  }
  return /*#__PURE__*/React.createElement("div", {
    id: "sell-car-model-screen",
    className: "flex flex-col h-full md:pb-6"
  }, /*#__PURE__*/React.createElement(FlowScreenHeaderSpacing, null, /*#__PURE__*/React.createElement(FlowStepTitle, null, tShort("sell_trade_v2/choose_model", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement(If, {
    condition: ((_state$availableModel = state.availableModels) === null || _state$availableModel === void 0 ? void 0 : _state$availableModel.length) > 8
  }, /*#__PURE__*/React.createElement(FlowSearchBar, {
    options: state.availableModels || [],
    searchFunction: searchModelsWrapper,
    onSearch: handleSearchResults,
    onSelect: handleModelSelect,
    limit: 200,
    getItemKey: function getItemKey(make) {
      return make.id;
    },
    placeholder: tShort("sell_trade_v2/search_brands_placeholder", {
      ns: "web_sell_trade"
    }),
    showResults: false,
    id: "model-search"
  }))), /*#__PURE__*/React.createElement(FlowScreenBodySpacing, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: (state === null || state === void 0 ? void 0 : state.isLoading) || loading.value
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(FlowOptionLoading, null)), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: (filteredModels === null || filteredModels === void 0 ? void 0 : filteredModels.length) !== 0
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-model-list",
    className: "flex flex-col gap-3 md:grid md:grid-cols-6 md:gap-8",
    dir: lang == 'ar' ? 'rtl' : 'ltr'
  }, filteredModels === null || filteredModels === void 0 ? void 0 : filteredModels.map(function (model) {
    var _state$selection, _state$selection$make;
    return /*#__PURE__*/React.createElement(FlowOption, {
      key: model.id,
      id: "sell-car-model-option-".concat(model.id),
      onClick: function onClick() {
        return handleModelSelect(model);
      }
    }, /*#__PURE__*/React.createElement(FlowOptionBody, {
      name: lang == 'ar' ? model.name : model === null || model === void 0 ? void 0 : model.seo_name,
      imgUrl: state === null || state === void 0 ? void 0 : (_state$selection = state.selection) === null || _state$selection === void 0 ? void 0 : (_state$selection$make = _state$selection.make) === null || _state$selection$make === void 0 ? void 0 : _state$selection$make.logo
    }));
  }))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(If, {
    condition: filteredModels !== null && searchTerm !== null
  }, /*#__PURE__*/React.createElement(FlowZeroResult, {
    searchTerm: searchTerm
  }))))))));
};
export default CarModelScreen;